import { Button, ButtonProps } from '@cmpsr/components';

export default function SubmitAccentButton({ children, ...props }: ButtonProps): React.ReactElement {
  return (
    <Button type="submit" variant="accent" width="100%" {...props}>
      {children}
    </Button>
  );
}
